module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ls-table-wrapper"
  }, [_c('div', {
    ref: "tableInner",
    staticClass: "ls-table-inner"
  }, [_c('table', {
    staticClass: "ls-table"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _vm._l((_vm.tableLayout.header), function(h) {
    return _c('th', [_c('div', {
      staticClass: "cell-inner"
    }, [_vm._v(_vm._s(h))])])
  })], 2)]), _vm._v(" "), (_vm.rows.length > 0) ? _c('tbody', _vm._l((_vm.tableDataSlice), function(r) {
    return _c('tr', [_c('th', [_c('div', {
      staticClass: "cell-inner"
    }, [_vm._v(_vm._s(r.key))])]), _vm._v(" "), _vm._l((r.data), function(v) {
      return _c('td', [_c('div', {
        staticClass: "cell-inner"
      }, [_vm._v(_vm._s(v))])])
    })], 2)
  }), 0) : _vm._e(), _vm._v(" "), _c('tfoot', [_c('tr', [_c('th', {
    staticClass: "tfoot-header"
  }, [_vm._v("TOTALS")]), _vm._v(" "), _vm._l((_vm.totals.data), function(v) {
    return _c('td', {
      staticClass: "tfoot-data"
    }, [_c('div', {
      staticClass: "cell-inner"
    }, [_vm._v(_vm._s(v))])])
  })], 2)])])]), _vm._v(" "), (_vm.rows.length > _vm.pageSize) ? _c('div', {
    staticClass: "ls-table-pagination"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.currentPage == 0
    },
    on: {
      "click": function($event) {
        _vm.currentPage--
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v(" prev\n    ")]), _vm._v("\n    |\n    "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.currentPage >= _vm.lastPage
    },
    on: {
      "click": function($event) {
        _vm.currentPage++
      }
    }
  }, [_vm._v("\n      next "), _c('i', {
    staticClass: "fa fa-arrow-right"
  })]), _vm._v(" "), (_vm.lastPage >= 0) ? _c('span', [_vm._v("page " + _vm._s(_vm.currentPage + 1) + " of " + _vm._s(_vm.lastPage + 1))]) : _vm._e(), _vm._v(" "), _c('span', [_c('small', [_vm._v("(" + _vm._s(_vm.rows.length) + " items)")])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-565582c6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/LsTable.vue
// module id = 648
// module chunks = 0